// TKT-2234 (F01): el modulo nuevo de Torre de Control solo se muestra a una allowlist de
// correos (Eduardo lo pidio el 15-sep, Jesus lo confirmo). Hasta liberarlo al resto de
// usuarios, sidebar, atajos de Inicio y la ruta pasan por aqui.

export const DEFAULT_ALLOWED_EMAILS = ['admin@espresso.com']

// Clave de localStorage SOLO para pruebas locales (APP_ENV === 'LOCAL'): permite probar
// ambos lados (con/sin permiso) sin reiniciar el dev server. En produccion no existe.
export const LOCAL_OVERRIDE_KEY = 'ct_allowed_emails'

export function parseAllowedEmails (raw) {
  if (typeof raw !== 'string') return []
  return raw.split(',').map(email => email.trim().toLowerCase()).filter(Boolean)
}

function readLocalOverride () {
  if (import.meta.env.APP_ENV !== 'LOCAL') return null
  try {
    return globalThis.localStorage ? globalThis.localStorage.getItem(LOCAL_OVERRIDE_KEY) : null
  } catch {
    return null
  }
}

// Lista efectiva: override local (solo LOCAL) > CONTROL_TOWER_ALLOWED_EMAILS > default.
export function getAllowedEmails (raw) {
  const source = raw !== undefined ? raw : (readLocalOverride() ?? import.meta.env.CONTROL_TOWER_ALLOWED_EMAILS)
  const parsed = parseAllowedEmails(source)
  return parsed.length ? parsed : DEFAULT_ALLOWED_EMAILS
}

export function canAccessControlTower (user, raw) {
  const email = user && typeof user.email === 'string' ? user.email.trim().toLowerCase() : ''
  if (!email) return false
  return getAllowedEmails(raw).includes(email)
}
